import React, { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

// Loged
export const RequireAuth: React.FC = () => {
  const { isAuthenticated, loading } = useContext(AuthContext);
  if (loading) return <p>Loading...</p>;
  return isAuthenticated ? <Outlet /> : <Navigate to="/login" replace />;
};

// Guests
export const RequireNoAuth: React.FC = () => {
  const { isAuthenticated, loading } = useContext(AuthContext);
  if (loading) return <p>Loading...</p>;
  return !isAuthenticated ? <Outlet /> : <Navigate to="/profile" replace />;
};
